import { Card, Row } from 'antd';
import React from 'react';
import { Redirect, Route, RouteComponentProps, Switch } from 'react-router';
import styled from 'styled-components';

import { AuthByToken } from './AuthByToken';
import { AuthWechatWork } from './AuthWechatWork';

const Container = styled.div`
  background: '#dfd';
  width: 100%;
  padding-top: 100px;
  height: 100vh;
`;

const Logo = styled.img`
  width: 240px;
  height: 240px;
`;
export const Auth = (props: RouteComponentProps) => {
  const hash = props.location.hash.match(/#(\S*)/);
  let returnPath = props.location.state;
  if (!props.location.state && hash) {
    returnPath = { returnPath: hash[1] };
  }

  return (
    <Container>
      <Row type="flex" justify="center">
        <Logo src={require('./image_logo.png')} />
      </Row>
      <Row type="flex" justify="center">
        <Card>
          <Switch>
            <Route path={`${props.match.path}/wechat-work`} component={AuthWechatWork} />
            <Route path={`${props.match.path}/token`} component={AuthByToken} />
            <Redirect to={{ pathname: `${props.match.path}/wechat-work`, state: returnPath }} />
          </Switch>
        </Card>
      </Row>
    </Container>
  );
};



// WEBPACK FOOTER //
// ./src/screens/auth/Auth.tsx